<div class="svi-navbar-mobile">
  <span class="spacer"></span>
  <div class=bar-menu #menuButton (click)="clicked()">
    <div class=top-bar></div>
    <div class=middle-bar></div>
    <div class=bottom-bar></div>
  </div>
</div>